module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n\n\n\n\n\n\n\n\n\n	<div class="result-header">\n		<div class="result-header__inner">\n			<div class="result-header__status"><span class="loader"></span><span class="label">Your filter returned 4 of the 12 available gateways</span></div>\n			<div class="result-header__options">\n			</div>\n		</div>\n	</div>\n\n\n	<div class="l-reports">\n		<div class="reports__header"></div>\n		<div class="reports-list__region"></div>\n		<div class="reports__body">\n			<div class="reports__body__inner reports-data__region"></div>\n		</div>\n	</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/modules/page-reports/list/templates/layout.html
// module id = 454
// module chunks = 0